import { observer } from 'mobx-react';
import { FC } from 'react';
import paymentCheckoutStore from '../../store/paymentCheckoutStore';
import { LoadingStatus } from '~/types/main';
import { leaveWithoutSaving } from '~/utils/modalConfirmations';
import { ProfilesScrollableList, TProfile } from '~/view/containers/ProfilesList';

const CheckoutProfiles: FC = observer((): JSX.Element => {
  const handleProfileClick = (profile: TProfile) => {
    if (paymentCheckoutStore.isDataEdited) {
      leaveWithoutSaving({ onConfirm: () => paymentCheckoutStore.selectProfile(profile.id) });
    } else {
      paymentCheckoutStore.selectProfile(profile.id);
    }
  };

  return (
    <ProfilesScrollableList
      profiles={paymentCheckoutStore.checkoutProfiles}
      loading={paymentCheckoutStore.loadingStatus === LoadingStatus.Loading}
      wrapperClassName="mr-6"
      selectedProfileId={paymentCheckoutStore.selectedCheckoutProfile.id}
      selectProfile={handleProfileClick}
    />
  );
});

export default CheckoutProfiles;
